<template>
  <div class="header"
       :style="{paddingTop: (headerTop ? headerTop : 30) + 'px', backgroundColor: headerBgColor ? headerBgColor : 'rgba(0,0,0,0)'}">
    <div style="height: 50px; width: 100%" class="flex-space-between">
      <div class="header-icon" @click="back">
        <img src="@/assets/icons/ic_back.svg" v-if="iconTheme == null">
        <img src="@/assets/icons/ic_back_white.svg" v-if="iconTheme == 'white'">
      </div>

      <div style="left: 0px; right: 0px; display: flex;justify-content:center; position: absolute;">
        <div :style="{color: iconTheme, maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '14px', fontWeight: 'bold', color: '#111111', textAlign: 'center'}" v-if="title !== null">{{title}}</div>
      </div>

      <div class="flex-center">
        <div class="header-icon" @click="go2cart" v-if="needCart !== 'false'">
          <img src="@/assets/icons/ic_cart.svg">
        </div>
        <div class="header-icon" @click="share" v-if="needShare !== 'false'">
          <img src="@/assets/icons/ic_share.svg" v-if="iconTheme == null">
          <img src="@/assets/icons/ic_share_white.svg" v-if="iconTheme == 'white'">
        </div>

        <div class="header-icon" @click="shortcut" v-if="needMore !== 'false'">
          <img src="@/assets/icons/icon_more_dot_black.svg" v-if="iconTheme == null">
          <img src="@/assets/icons/ic_more_dot_white.svg" v-if="iconTheme == 'white'">
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import JSBridge from "../libs/JSBridge";
const router = require("@/libs/router");
const utils = require("@/libs/utils");

export default {
  props: ["headerBgColor", "needCart", "needShare", "shareImgUrl", "shareEvent", "shareSource", "iconTheme", "needMore", "title", "partialPoster", "sharePath", "shareTitle"],
  data() {
    return {
      headerTop: 0,
      headerTransparent: true,
    };
  },
  mounted() {
    if (window.injectProperty && window.injectProperty.prerender) {
      return;
    }
    JSBridge.callHandler('getMediaPadding', '', res => {
      self.headerTop = res.top
    })
  },
  methods: {
    back() {
      router.open("link", {
        link: {
          resolvedUrl: 'https://ikeaapp/popCurrent'
        }
      });
    },
    go2cart() {
      router.open("link", {
        link: {
          resolvedUrl: 'https://ikeaapp/shopping_cart'
        }
      });
    },
    share() {
      let param = {
        event: this.shareEvent ? this.shareEvent : 'web-share',
        params: {
          'source': this.shareSource ? this.shareSource : 'web'
        }
      }
      JSBridge.callHandler('onTrackEvent', param)

      var shareInfo = {
          title: '',
          msg: '',
          trackSource: this.shareSource ? this.shareSource : 'web'
      }
      if (this.partialPoster != null) {
        shareInfo['partialPoster'] = encodeURIComponent(this.partialPoster);
      }
      if (this.shareImgUrl != null) {
        shareInfo['poster'] = encodeURIComponent(this.shareImgUrl);
      }
      if (this.sharePath != null) {
        shareInfo['path'] = utils.getClientPlatform() == "ANDROID" ? encodeURIComponent(this.sharePath) : this.sharePath;
        shareInfo['mpAppUserName'] = "gh_f8c80781c128";
      }
      if (this.shareTitle) {
        shareInfo['title'] = this.shareTitle;
      }

      router.open("shareInfo", {
        data: encodeURIComponent(JSON.stringify(shareInfo))
      })
    },
    shortcut() {
      router.open("link", {
        link: {
          resolvedUrl: 'https://ikeaapp/short_cut'
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 30px 0 0 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 999;
    background-repeat: no-repeat;
    background-size: 100%;
    transition: all 0.4s linear;
  }
  .header-icon {
    height: 50px;
    width: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/TitleBar.vue